import { createSignal, onCleanup, onMount, Show } from "solid-js";

export const CountdownTimer = (props: {
  seconds?: number;
  minutes?: number;
  hours?: number;
  days?: number;
}) => {
  const [seconds, setSeconds] = createSignal(props.seconds ?? 0);
  const [minutes, setMinutes] = createSignal(props.minutes ?? 0);
  const [hours, setHours] = createSignal(props.hours ?? 0);
  const [days, setDays] = createSignal(props.days ?? 0);
  const [timerInterval, setTimerInterval] = createSignal<NodeJS.Timer>();

  onMount(() => {
    const timerInterval = setInterval(() => {
      if (hours() <= 0) {
        if (days() !== 0) {
          setHours(23);
          setDays((current) => current - 1);
        }
      }
      if (minutes() <= 0) {
        if (hours() !== 0) {
          setMinutes(59);
          setHours((current) => current - 1);
        }
      }

      if (seconds() <= 0) {
        if (minutes() !== 0) {
          setMinutes((current) => current - 1);
          setSeconds(60);
        }
      } else {
        if (seconds() !== 0) {
          setSeconds((current) => current - 1);
        }
      }
    }, 1000);

    setTimerInterval(timerInterval);
  });

  onCleanup(() => {
    if (timerInterval() !== null) {
      clearInterval(timerInterval() as unknown as NodeJS.Timeout);
    }
  });

  const SECTION_CLASSES =
    "flex flex-col p-2 bg-background-dark rounded-box text-neutral-content";
  const COUNTDOWN_CLASSES =
    "w-full flex items-center justify-center countdown font-mono text-2xl sm:text-3xl md:text-4xl";

  return (
    <div class="grid grid-flow-col gap-5 text-center auto-cols-max pt-4 justify-center">
      <Show when={days() > 0}>
        <div class={SECTION_CLASSES}>
          <span class={COUNTDOWN_CLASSES}>{days()}</span>
          days
        </div>
      </Show>
      <Show when={hours() > 0}>
        <div class={SECTION_CLASSES}>
          <span class={COUNTDOWN_CLASSES}>
            <span style={{ "--value": hours() }}></span>
          </span>
          hours
        </div>
      </Show>
      <div class={SECTION_CLASSES}>
        <span class={COUNTDOWN_CLASSES}>
          <span style={{ "--value": minutes() }}></span>
        </span>
        min
      </div>
      <div class={SECTION_CLASSES}>
        <span class={COUNTDOWN_CLASSES}>
          <span style={{ "--value": seconds() }}></span>
        </span>
        sec
      </div>
    </div>
  );
};

export default CountdownTimer;
